import cn from 'classnames';
import * as React from 'react';

import AppLink, { MobileAppType } from './AppLink';

import s from './AppLinks.module.scss';

const AppLinks: React.FC = () => {
  return (
    <ul className={s.appLinks}>
      {Object.values(MobileAppType).map((type) => (
        <li className={cn(s.appLinks__item, s[`appLinks__item_${type}`])} key={type}>
          <AppLink type={type} />
        </li>
      ))}
    </ul>
  );
};

export default AppLinks;
